import { render, staticRenderFns } from "./ManageCorrespondences.vue?vue&type=template&id=71e98f27"
import script from "./ManageCorrespondences.vue?vue&type=script&lang=js"
export * from "./ManageCorrespondences.vue?vue&type=script&lang=js"
import style0 from "./ManageCorrespondences.vue?vue&type=style&index=0&id=71e98f27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports